/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Traces_User_SystemInputs */

const es_admin_traces_user_system = /** @type {(inputs: Admin_Traces_User_SystemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`sistema`)
};

const en_admin_traces_user_system = /** @type {(inputs: Admin_Traces_User_SystemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`system`)
};

/**
* | output |
* | --- |
* | "system" |
*
* @param {Admin_Traces_User_SystemInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const admin_traces_user_system = /** @type {((inputs?: Admin_Traces_User_SystemInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Traces_User_SystemInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_admin_traces_user_system(inputs)
	return en_admin_traces_user_system(inputs)
});
export { admin_traces_user_system as "admin.traces.user.system" }